import { Button } from 'antd';

import styles from './styles.module.css';

interface CardsProps {
  icon: React.ReactNode | JSX.Element;
  title: string;
  text: string;
  buttonText?: string;
  link?: string;
}

export const CheckinCard = ({ icon, title, text, buttonText, link }: CardsProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.iconWrapper}>{icon}</div>
      <div>
        <p className={styles.title}>{title}</p>
        <p className={styles.text}>{text}</p>
      </div>
      {buttonText && link && (
        <a href={link} target='_blank' rel='noreferrer'>
          <Button className={styles.button}>{buttonText}</Button>
        </a>
      )}
    </div>
  );
};
